var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"widget-type":"html"}},[_c('div',{class:_vm.options.customClass,attrs:{"data-model":_vm.fieldName},domProps:{"innerHTML":_vm._s(_vm.value)}})])}
var staticRenderFns = []

export { render, staticRenderFns }